import React, { useState } from 'react';
import Button from '../Button/Button';
import DealCreateCarsModal from '../../pages/Deal/DealCreate/DealCreateCarsModal';
import reassignCar from '../../api/deals/reassignCar';
import alert from '../../helpers/alert';

/**
 * ÐÐ°Ð¼ÐµÐ½Ð° Ð¼Ð°ÑÐ¸Ð½Ñ Ð² ÑÐ´ÐµÐ»ÐºÐµ â Ð´Ð¾ÑÑÑÐ¿Ð½Ð° Ð²ÑÐµÐ³Ð´Ð° Ð¿ÐµÑÐµÐ´ Ð²ÑÐ±Ð¾ÑÐ¾Ð¼ Ð¾ÑÑÐµÑÐ° Ð±Ð°Ð½ÐºÐ°, Ð½Ðµ ÑÐ¾Ð»ÑÐºÐ¾
 * Ð´Ð»Ñ Ð¿ÑÐ¾ÑÑÐ¾ÑÐµÐ½Ð½ÑÑ (TTL) ÑÐ´ÐµÐ»Ð¾Ðº. ÐÑÐ°Ð²Ð¸Ñ ÑÐ¾Ñ Ð¶Ðµ Order (ÑÐ¾Ñ Ð¶Ðµ chunkId), Ð½Ð¾Ð²ÑÑ
 * ÑÐ´ÐµÐ»ÐºÑ Ð½Ðµ ÑÐ¾Ð·Ð´Ð°ÑÑ. ÐÐ¾Ð´Ð±Ð¾Ñ Ð¾Ð³ÑÐ°Ð½Ð¸ÑÐµÐ½ ÑÐ¾Ð¹ Ð¶Ðµ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸ÐµÐ¹ Ð¸ ÑÐ²ÐµÑÐ¾Ð¼, ÑÑÐ¾ Ð¸ Ñ
 * Ð¸ÑÑÐ¾Ð´Ð½Ð¾Ð¹ Ð¼Ð°ÑÐ¸Ð½Ñ.
 */
const ReassignCarButton = ({ orderId, complectationId, color, onDone }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!orderId) return null;

  const handleSubmit = async (cars) => {
    // Ð¢Ð°Ð±Ð»Ð¸ÑÐ° (Cars -> Table) Ð¾ÑÐ´Ð°ÑÑ ÑÑÑÑÐµ ÑÑÑÐ¾ÐºÐ¸ Ð¾ÑÐ²ÐµÑÐ° /shop/getItems, ÑÐ°Ð¼ id.
    // ÐÐ¾Ð»Ðµ value ÐµÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ñ SelectCars, ÑÑÐ¾ Ð´ÑÑÐ³Ð¾Ð¹ ÐºÐ¾Ð¼Ð¿Ð¾Ð½ÐµÐ½Ñ.
    const newCarId = cars?.[0]?.id;
    if (!newCarId) {
      return alert.error('ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ');
    }

    setLoading(true);
    try {
      await reassignCar({ orderId, newCarId });
      setIsOpen(false);
      onDone?.();
    } catch (e) {
      alert.error(e?.response?.data?.errorMessage || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð¼ÐµÐ½Ð¸ÑÑ Ð¼Ð°ÑÐ¸Ð½Ñ');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button text="ÐÐ°Ð¼ÐµÐ½Ð¸ÑÑ Ð¼Ð°ÑÐ¸Ð½Ñ" onClick={() => setIsOpen(true)} disabled={loading} />
      {isOpen && (
        <DealCreateCarsModal
          isOpen={isOpen}
          onCancel={() => setIsOpen(false)}
          onClose={() => setIsOpen(false)}
          onSubmit={handleSubmit}
          defaultQueryParams={{ stock: true, complectationId, color }}
        />
      )}
    </>
  );
};

export default ReassignCarButton;
